import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import getQuery from '../../helpers/api/get-query'
import ProductType from '../../types/api/product-type'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'

export const productTypesApi = createApi({
    reducerPath: 'productTypesApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['ProductTypes'],
    endpoints: builder => ({
        getProductTypes: builder.query<Strapi<ProductType>, EndpointQueryParameters | void>({
            query: getQuery('/product-types'),
            providesTags: ['ProductTypes'],
        }),
    }),
})

export const { useLazyGetProductTypesQuery } = productTypesApi
